var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#e9e9e9;}.d{fill:silver;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 192,
    height: 192,
    transform: "translate(580 276)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-580 -276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(580 276)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.935 86.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M147.052,147.815a28.14,28.14,0,1,0,28.14,28.14A28.14,28.14,0,0,0,147.052,147.815Zm0,49.109a20.968,20.968,0,1,1,20.968-20.968,20.968,20.968,0,0,1-20.968,20.968Z",
    transform: "translate(-82.02 -110.923)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15.044,
    cy: 15.044,
    r: 15.044,
    transform: "translate(49.988 49.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M196.645,130.065H85.161a9.29,9.29,0,0,0-9.29,9.29v65.032a9.29,9.29,0,0,0,9.29,9.29H196.645a9.29,9.29,0,0,0,9.29-9.29V139.355A9.29,9.29,0,0,0,196.645,130.065ZM140.9,207.484a34.065,34.065,0,1,1,34.065-34.065A34.065,34.065,0,0,1,140.9,207.484Z",
    transform: "translate(-75.871 -108.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M174.986,120.258l-3.249-9.269a9.29,9.29,0,0,0-8.767-6.215H131.216a9.29,9.29,0,0,0-8.767,6.216l-3.248,9.268Z",
    transform: "translate(-82.061 -104.774)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M149.161,3.613H12.9a9.29,9.29,0,0,0-9.29,9.29V124.387a9.29,9.29,0,0,0,9.29,9.29H149.161a9.29,9.29,0,0,0,9.29-9.29V12.9A9.29,9.29,0,0,0,149.161,3.613Zm3.1,120.774a3.1,3.1,0,0,1-3.1,3.1H12.9a3.1,3.1,0,0,1-3.1-3.1V12.9a3.1,3.1,0,0,1,3.1-3.1H149.161a3.1,3.1,0,0,1,3.1,3.1Z",
    transform: "translate(-3.613 -3.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M142.452,21.677H24.774a3.1,3.1,0,0,0-3.1,3.1v92.9a3.1,3.1,0,0,0,3.1,3.1H142.452a3.1,3.1,0,0,0,3.1-3.1v-92.9A3.1,3.1,0,0,0,142.452,21.677Zm-3.1,6.194V86.71h-17.3L95.093,59.746a3.1,3.1,0,0,0-3.989-.331l-20.423,14.6L54.717,59.644a3.1,3.1,0,0,0-3.79-.276L27.871,74.731V27.871ZM27.871,114.581V92.9H52.645a3.1,3.1,0,1,0,0-6.194H27.871V82.173L52.36,65.847,81.541,92.107a3.1,3.1,0,1,0,4.144-4.6L75.4,78.246,92.569,65.98,113.3,86.71H102.194a3.1,3.1,0,1,0,0,6.194h37.161v21.677Z",
    transform: "translate(-6.194 -6.194)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M135.226,60.9a12.387,12.387,0,1,0-12.387-12.387A12.387,12.387,0,0,0,135.226,60.9Zm0-18.581a6.194,6.194,0,1,1-6.194,6.194A6.194,6.194,0,0,1,135.226,42.323Z",
    transform: "translate(-20.645 -8.258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogPhoto);
export default __webpack_public_path__ + "static/media/dialog-photo.abe9a6ef91de21781f7cf4300f97b922.svg";
export { ForwardRef as ReactComponent };